export const updateAPIErrorState = (data: any) => ({
  type: "API_ERROR_STATE",
  payload: data,
});
